<template>
    <div>
      <modal name="autorizacion" :width="500" :height="'auto'" :clickToClose="false" :scrollable="true">
        <div class="modal-content modalContent">
          <span class="closebtn" @click="closeModal">&times;</span>
          <div class="text-center mt-4">
            <h3 class="with-lines">Autorizacion</h3>
          </div>
          <div class="container text-center">
            <div>
              <div class="row">
                <div class="col-4">
                  <label class="col-form-label">Cobertura</label>
                </div>
                <div class="col-7">
                  <select class="form-control" v-model="localnoEstimacion" @change="updateEstimacion">
                    <option selected disabled value="">--Selecciona</option>
                    <option v-for="(item, i) in arrCoberturas" :key="i" :value="item.NumEstimacion">{{item.DescCobertura}} - ${{ item.Saldo }}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-4">
                  <label class="col-form-label">Tipo</label>
                </div>
                <div class="col-7">
                  <select class="form-control" v-model="localtipoIG" @change="updateIG">
                    <option selected disabled value="">--Selecciona</option>
                    <option value="I">Indemnización</option>
                    <option value="G">Gastos</option>
                  </select>
                </div>
              </div>
              <div v-if="localtipoIG === 'G'" class="row mt-2">
                <div class="col-4">
                  <label class="col-form-label">Gasto</label>
                </div>
                <div class="col-7">
                  <select class="form-control" v-model="localgastos" @change="updateGastos">
                    <option selected disabled value="">--Seleccina</option>
                    <option value="25">Honorarios</option>
                    <option value="26">Gasto</option>
                    <option value="35">Mensajeria</option>
                    <option value="45">Grúas</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-4">
                  <label class="col-form-label">Porcentaje de IVA</label>
                </div>
                <div class="col-7">
                  <select class="form-control" v-model="localporcentajeIVA" @change="updatePorcentajeIVA">
                    <option selected disabled value="">--Seleccina</option>
                    <option value="01">IVA 16% Retención 10.67%</option>
                    <option value="02">IVA  8% Retención  5.33%</option>
                    <option value="03">IVA  0% Retención  0.00%</option>
                    <option value="04">IVA 16% Retención  4.00%</option>
                    <option value="05">IVA  0% Retención  0.00%</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-4">
                  <label class="col-form-label">Retención</label>
                </div>
                <div class="col-2 mt-2">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="IVA" v-model="localiva" @change="updateIVA">
                    <label class="form-check-label" for="flexCheckDefault">
                      IVA
                    </label>
                  </div>
                </div>
                <div class="col-2 mt-2">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="ISR" v-model="localisr" @change="updateISR">
                    <label class="form-check-label" for="flexCheckChecked">
                      ISR
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center m-4">
              <button class="btn btn-blue col-5" @click="autorizacionIndividual"><i style="color:#fffdfd;" class="fas fa-check-circle mr-2"></i> Autorizar</button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      noEstimacion: String,
      tipoIG: String,
      gastos: String,
      porcentajeIVA: String,
      iva: String,
      isr: String,
      arrCoberturas: Array,
      autorizacionIndividual: Function,
    },
    data() {
      return {
        localnoEstimacion: this.noEstimacion,
        localtipoIG: this.tipoIG,
        localgastos: this.gastos,
        localporcentajeIVA: this.porcentajeIVA,
        localiva: this.iva,
        localisr: this.isr,
      };
    },
    methods: {
      closeModal() {
        this.$modal.hide('autorizacion');
      },
      updateEstimacion() {
        this.$emit('update:noEstimacion', this.localnoEstimacion);
      },
      updateIG() {
        this.$emit('update:tipoIG', this.localtipoIG);
      },
      updateGastos() {
        this.$emit('update:gastos', this.localgastos);
      },
      updateIVA() {
        this.$emit('update:iva', this.localiva);
      },
      updateISR() {
        this.$emit('update:isr', this.localisr);
      },
      updatePorcentajeIVA() {
        this.$emit('update:porcentajeIVA', this.localporcentajeIVA);
      },
    },
    watch: {
      noEstimacion(newVal) {
        this.localnoEstimacion = newVal;
      },
      tipoIG(newVal) {
        this.localtipoIG = newVal;
      },
      gastos(newVal) {
        this.localgastos = newVal;
      },
      iva(newVal) {
        this.localiva = newVal;
      },
      isr(newVal) {
        this.localisr = newVal;
      },
      porcentajeIVA(newVal) {
        this.localporcentajeIVA = newVal;
      },
    },
  };
  </script>
  <style>
  .with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.with-lines::before,
.with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #003c717a;
    margin: 0 10px;
}
.btn-blue{
        border-radius: 10px;
        background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
        border: #003c71;
        color: #ffffff;
    }
</style>
  